// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://apigopaljewels.manjitjewellers.com/",
});

export default axiosInstance;

// export const weburl = "https://manjit-jewellers-backend.onrender.com/";
export const weburl = "https://apigopaljewels.manjitjewellers.com/";
export const testurl = "https://apigopaljewels.manjitjewellers.com/";
export const ImageServer = "https://gopaljewelscloud.manjitjewellers.com/";

export const shopurl = "http://admingopal.servicekarwalo.com/";
export const mainurl = "https://gopal.servicekarwalo.com/";
export const fronturl = "https://gopal.servicekarwalo.com/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;